export const AUTH_PROVIDER_KEY = "auth_provider";
export const MICROSOFT_AUTH_PROVIDER = "microsoft";
export const MICROSOFT_SESSION_USER_KEY = "microsoft_session_user";
export const MS_LOGIN_PENDING_KEY = "ms_login_pending";
export const MS_LOGIN_EMAIL_KEY = "ms_login_email";
/** Django JWT session started via Microsoft SSO (skip forced password change). */
export const AZURE_SSO_SESSION_KEY = "azure_sso_session";
